module.exports = __webpack_public_path__ + "img/right-leg_active.d324f8f3.png";